import React, { Fragment } from "react";
import Header from "./header";
import Footer from "./footer";
import Loading from "../../reusable/Loading/Loading";

const index = ({ loading, children, show = true }) => {
  return (
    <Fragment >
      <main >
        {show && <Header />}
        <div className="page">
          {loading ? <Loading loading={loading}>{children}</Loading> : children}
        </div>
        {show && <Footer />}
      </main>
    </Fragment>
  );
};

export default index;
